/**
 * Mio password strength heuristic (4-bucket meter).
 *
 * Mockup state 04 shows a 4-segment bar with 3 lit for a 12-char
 * password. We avoid pulling zxcvbn (~80KB) and use a cheap
 * deterministic score:
 *
 *   +1 if length >= 8
 *   +1 if length >= 12
 *   +1 if has BOTH letters AND digits
 *   +1 if has a non-alphanumeric symbol
 *
 * Returns 0..4 inclusive.
 */

export function passwordStrength(pw: string): number {
  if (!pw) return 0;
  let score = 0;
  if (pw.length >= 8) score++;
  if (pw.length >= 12) score++;
  const hasLetter = /[A-Za-z]/.test(pw);
  const hasDigit = /\d/.test(pw);
  if (hasLetter && hasDigit) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;
  return score;
}
